<template>
  <div>
    <el-drawer
      ref="drawer"
      :title="title"
      destroy-on-close
      :visible.sync="drawer"
      direction="rtl"
      :append-to-body="true"
      :before-close="handleClose"
      :width="drawerWidth"
    >
      <component 
        :is="activeForm" 
        v-model="form"
      ></component>
    </el-drawer>
  </div>
</template>

<script>
import MenuTaskProperty from './MenuTaskProperty.vue'
import TransitionProperty from './TransitionProperty.vue'

export default {
  components: {
    MenuTaskProperty,
    TransitionProperty
  },
  props: {
    value: {
      type: Object,
      default() {
        return {}
      }
    },
    node: {
      type: Object,
      default() {
        return {}
      }
    },
    lf: {
      type: Object,
      default() {
        return null
      }
    }
  },
  data() {
    return {
      drawer: false,
      form: {},
      nodeId: undefined,
      activeForm: undefined
    }
  },
  computed: {
    title() {
      if (this.node && this.node.type === 'flow:transition') {
        return '设置连线属性'
      }
      return '设置菜单节点属性'
    },
    drawerWidth() {
      const min = 450
      const maxPercent = 0.40
      const winWidth = document.documentElement.clientWidth || window.innerWidth
      const calc = Math.floor(winWidth * maxPercent)
      return calc < min ? `${min}px` : `${calc}px`
    }
  },
  watch: {
    node(n) {
      if (!n) return
      
      this.nodeId = n.id
      const props = n.properties || {}
      
      this.form = {
        name: n.id,
        displayName: n.text instanceof Object ? n.text.value : n.text,
        ...props
      }
      
    },
    'form.displayName'(n) {
      if (this.nodeId) {
        this.lf.updateText(this.nodeId, n)
      }
    },
    form: {
      handler(n) {
        if (this.nodeId && n) {
          // 更新节点属性
          const updateProps = { ...n }
          delete updateProps.name
          delete updateProps.displayName
          
          this.lf.setProperties(this.nodeId, updateProps)
        }
      },
      deep: true
    }
  },
  methods: {
    show(node) {
      if (!node || !node.type) return
      
      this.node = node
      
      switch(node.type) {
        case 'flow:menutask':
          this.activeForm = 'menu-task-property'
          break
        case 'flow:transition':
          this.activeForm = 'transition-property'
          break
        default:
          return
      }
      
      this.drawer = true
    },
    handleClose(done) {
      console.log('PropertySetting 关闭')
      // 清空数据
      this.form = {}
      this.nodeId = undefined
      this.activeForm = undefined
      this.drawer = false
      if (done) done()
    }
  }
}
</script>

<style scoped>
::v-deep .el-drawer__body {
  overflow-y: scroll;
}

::v-deep .el-drawer__container ::-webkit-scrollbar {
  display: none;
}

::v-deep .el-drawer__header {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
</style>
